import React from 'react';
import styled from '@emotion/styled/macro';

const GroupedTablesContainer = ({ children, className }) => {
  return (
    <div data-testid="grouped-table-container" className={className}>
      {children}
    </div>
  );
};

const StyledGroupedTablesContainer = styled(GroupedTablesContainer)``;

export default StyledGroupedTablesContainer;
